import { Provider } from '@angular/core';
import { GeoLoactionRepository } from './domain/geolocation.repository';
import { GeolocationHttpRepository } from './infrastructure/repository/geolocation-http.repository';
import { GeoLocationService } from './presentation/service/geolocation.service';

/**
 * Providers para Geolocation Repository
 *
 */
export function provideGeolocationRepository(): Provider[] {
  return [
    {
      provide: GeoLoactionRepository,
      useClass: GeolocationHttpRepository,
    },
    GeoLocationService,
  ];
}
